export const LOCATION_MISMATCH_BAR = 'location-mismatch-bar';
export const LOCATION_MISMATCH_COUNTRY = 'location-mismatch-country';
export const LOCATION_MISMATCH_LANGUAGE = 'location-mismatch-language';
export const LOCATION_MISMATCH_CHECKED = 'locationMismatchChecked';
